import ScalarCodeBlock_vue_vue_type_script_setup_true_lang_default from "./ScalarCodeBlock.vue.script.js";
/* empty css                              */
//#region src/components/ScalarCodeBlock/ScalarCodeBlock.vue
var ScalarCodeBlock_default = ScalarCodeBlock_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCodeBlock_default as default };

//# sourceMappingURL=ScalarCodeBlock.vue.js.map